var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, ViewChild } from '@angular/core';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { PullGooglePlaceTypeModalActions } from './pull.google.place.type.modal.provider';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { ToggleAndDataSourceStore } from '../../../stores/hub.calendar.store';
import { LocalStorageService } from '../../../services/localStorageService';
var PullGooglePlaceTypeModalComponent = /** @class */ (function (_super) {
    __extends(PullGooglePlaceTypeModalComponent, _super);
    function PullGooglePlaceTypeModalComponent(dialogRef, actions, toggleAndDataSourceStore, imageService) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.actions = actions;
        _this.toggleAndDataSourceStore = toggleAndDataSourceStore;
        _this.imageService = imageService;
        _this.isSelectAll = false;
        _this.sources = [
            {
                text: 'Shopping',
                all: false,
                types: [
                    {
                        text: 'Store',
                        value: 'store',
                        checked: false,
                    },
                    {
                        text: 'Bicycle store',
                        value: 'bicycle_store',
                        checked: false,
                    },
                    {
                        text: 'Book store',
                        value: 'book_store',
                        checked: false,
                    },
                    {
                        text: 'Shopping mall',
                        value: 'shopping_mall',
                        checked: false,
                    },
                    {
                        text: 'Florist',
                        value: 'florist',
                        checked: false,
                    },
                    {
                        text: 'Jewelry shop',
                        value: 'jewelry_store',
                        checked: false,
                    },
                    {
                        text: 'Clothing store',
                        value: 'clothing_store',
                        checked: false,
                    },
                    {
                        text: 'Shoe store',
                        value: 'shoe_store',
                        checked: false,
                    },
                    {
                        text: 'Supermarket',
                        value: 'supermarket',
                        checked: false,
                    },
                    {
                        text: 'Pet store',
                        value: 'pet_store',
                        checked: false,
                    },
                ],
            },
            {
                text: 'Dining',
                all: false,
                types: [
                    {
                        text: 'Bakery',
                        value: 'bakery',
                        checked: false,
                    },
                    {
                        text: 'Bar',
                        value: 'bar',
                        checked: false,
                    },
                    {
                        text: 'Cafe',
                        value: 'cafe',
                        checked: false,
                    },
                    {
                        text: 'Restaurant',
                        value: 'restaurant',
                        checked: false,
                    },
                    {
                        text: 'Food',
                        value: 'food',
                        checked: false,
                    },
                ],
            },
            {
                text: 'Accommodation',
                all: false,
                types: [
                    {
                        text: 'Campground',
                        value: 'campground',
                        checked: false,
                    },
                    {
                        text: 'Lodging',
                        value: 'lodging',
                        checked: false,
                    },
                    {
                        text: 'RV Park',
                        value: 'rv_park',
                        checked: false,
                    },
                    {
                        text: 'Real Estate Agency',
                        value: 'real_estate_agency',
                        checked: false,
                    },
                ],
            },
            {
                text: 'Activity',
                all: false,
                types: [
                    {
                        text: 'Amusement park',
                        value: 'amusement_park',
                        checked: false,
                    },
                    {
                        text: 'Aquarium',
                        value: 'aquarium',
                        checked: false,
                    },
                    {
                        text: 'Bowling Alley',
                        value: 'bowling_alley',
                        checked: false,
                    },
                    {
                        text: 'Library',
                        value: 'library',
                        checked: false,
                    },
                    {
                        text: 'Movie Theater',
                        value: 'movie_theater',
                        checked: false,
                    },
                    {
                        text: 'Tourist Attraction',
                        value: 'tourist_attraction',
                        checked: false,
                    },
                    {
                        text: 'Zoo',
                        value: 'zoo',
                        checked: false,
                    },
                ],
            },
            {
                text: 'Arts & Culture',
                all: false,
                types: [
                    {
                        text: 'Art Gallery',
                        value: 'art_gallery',
                        checked: false,
                    },
                    {
                        text: 'Museum',
                        value: 'museum',
                        checked: false,
                    },
                ],
            },
            {
                text: 'Travel',
                all: false,
                types: [
                    {
                        text: 'Airport',
                        value: 'airport',
                        checked: false,
                    },
                    {
                        text: 'Car Rental',
                        value: 'car_rental',
                        checked: false,
                    },
                    {
                        text: 'Light Rail Station',
                        value: 'light_rail_station',
                        checked: false,
                    },
                    {
                        text: 'Taxi Stand',
                        value: 'taxi_stand',
                        checked: false,
                    },
                    {
                        text: 'Train Station',
                        value: 'train_station',
                        checked: false,
                    },
                    {
                        text: 'Transit Station',
                        value: 'transit_station',
                        checked: false,
                    },
                    {
                        text: 'Parking',
                        value: 'parking',
                        checked: false,
                    },
                    {
                        text: 'Bus Station',
                        value: 'bus_station',
                        checked: false,
                    },
                    {
                        text: 'Subway Station',
                        value: 'subway_station',
                        checked: false,
                    },
                ],
            },
            {
                text: 'Entertainment',
                all: false,
                types: [
                    {
                        text: 'Movie Theater',
                        value: 'movie_theater',
                        checked: false,
                    },
                    {
                        text: 'Night Club',
                        value: 'night_club',
                        checked: false,
                    },
                    {
                        text: 'Tourist Attraction',
                        value: 'tourist_attraction',
                        checked: false,
                    },
                    {
                        text: 'Casino',
                        value: 'casino',
                        checked: false,
                    },
                    {
                        text: 'Stadium',
                        value: 'stadium',
                        checked: false,
                    },
                ],
            },
            {
                text: 'Outdoor',
                all: false,
                types: [
                    {
                        text: 'Park',
                        value: 'park',
                        checked: false,
                    },
                ],
            },
            {
                text: 'Wellness',
                all: false,
                types: [
                    {
                        text: 'Spa',
                        value: 'spa',
                        checked: false,
                    },
                    {
                        text: 'Gym',
                        value: 'gym',
                        checked: false,
                    },
                ],
            },
            {
                text: 'Other',
                all: false,
                types: [
                    {
                        text: 'Local Government Office',
                        value: 'local_government_office',
                        checked: false,
                    },
                    {
                        text: 'Locality',
                        value: 'locality',
                        checked: false,
                    },
                    {
                        text: 'Political',
                        value: 'political',
                        checked: false,
                    },
                ],
            },
        ];
        _this.sourceOfAreaBusiness = [
            {
                text: 'Beauty',
                all: false,
                types: [
                    {
                        text: 'Beauty Salon',
                        value: 'beauty_salon',
                        checked: false,
                    },
                    {
                        text: 'Hair Care',
                        value: 'hair_care',
                        checked: false,
                    },
                    {
                        text: 'Spas',
                        value: 'spa',
                        checked: false,
                    },
                ],
            },
            {
                text: 'Cars & Motor Services',
                all: false,
                types: [
                    {
                        text: 'Bicycle Store',
                        value: 'bicycle_store',
                        checked: false,
                    },
                    {
                        text: 'Car Rental',
                        value: 'car_rental',
                        checked: false,
                    },
                    {
                        text: 'Car Repair',
                        value: 'car_repair',
                        checked: false,
                    },
                    {
                        text: 'Car Wash',
                        value: 'car_wash',
                        checked: false,
                    },
                    {
                        text: 'Parking',
                        value: 'parking',
                        checked: false,
                    },
                ],
            },
            {
                text: 'Cleaning Services',
                all: false,
                types: [
                    {
                        text: 'Laundry',
                        value: 'laundry',
                        checked: false,
                    },
                ],
            },
            {
                text: 'Pet Services',
                all: false,
                types: [
                    {
                        text: 'Pet Store',
                        value: 'pet_store',
                        checked: false,
                    },
                    {
                        text: 'Veterinary Care',
                        value: 'veterinary_care',
                        checked: false,
                    },
                ],
            },
            {
                text: 'Convenience & Pharmacies',
                all: false,
                types: [
                    {
                        text: 'Pharmacy',
                        value: 'pharmacy',
                        checked: false,
                    },
                    {
                        text: 'Drugstore',
                        value: 'drugstore',
                        checked: false,
                    },
                    {
                        text: 'Convenience Store',
                        value: 'convenience_store',
                        checked: false,
                    },
                    {
                        text: 'Supermarket',
                        value: 'supermarket',
                        checked: false,
                    },
                ],
            },
            {
                text: 'Other Types',
                all: false,
                types: [
                    {
                        text: 'Real Estate Agency',
                        value: 'real_estate_agency',
                        checked: false,
                    }, {
                        text: 'Hospital',
                        value: 'hospital',
                        checked: false,
                    },
                ],
            },
        ];
        _this.sourceOfLocalSecrets = [
            {
                text: 'Art and Culture',
                all: false,
                types: [
                    {
                        text: 'Art Galleries & Exhibitions',
                        value: 'art_gallery',
                        checked: false,
                    },
                    {
                        text: 'Museums',
                        value: 'museum',
                        checked: false,
                    },
                    {
                        text: 'Historical Sites',
                        value: 'landmark',
                        checked: false,
                    },
                    {
                        text: 'Libraries',
                        value: 'library',
                        checked: false,
                    },
                    {
                        text: 'Cinemas',
                        value: 'movie_theater',
                        checked: false,
                    },
                ],
            },
            {
                text: 'Food and Drink',
                all: false,
                types: [
                    {
                        text: 'Restaurants',
                        value: 'restaurant',
                        checked: false,
                    },
                    {
                        text: 'Bakeries & Cafes',
                        value: 'bakery,cafe',
                        checked: false,
                    },
                    {
                        text: 'Delivery Food & Drinks',
                        value: 'meal_delivery,meal_takeaway',
                        checked: false,
                    },
                    {
                        text: 'Sports Bars',
                        value: 'bar',
                        checked: false,
                    },
                    {
                        text: 'Local Supermarkets',
                        value: 'supermarket,liquor_store',
                        checked: false,
                    },
                ],
            },
            {
                text: 'Nightlife',
                all: false,
                types: [
                    {
                        text: 'Disco/Night Clubs',
                        value: 'night_club',
                        checked: false,
                    },
                    {
                        text: 'Bars & Pubs',
                        value: 'convenience_store',
                        checked: false,
                    },
                    {
                        text: 'Snacks & Fast Food',
                        value: 'convenience_store',
                        checked: false,
                    },
                ],
            },
            {
                text: 'Trip & Tours Planner',
                all: false,
                types: [
                    {
                        text: 'Guided Tours',
                        value: 'travel_agency',
                        checked: false,
                    },
                    {
                        text: 'Attractions / View Points',
                        value: 'tourist_attraction',
                        checked: false,
                    },
                    {
                        text: 'Local Zoo',
                        value: 'zoo',
                        checked: false,
                    },
                    {
                        text: 'Parks and Gardens',
                        value: 'park',
                        checked: false,
                    },
                    {
                        text: 'Amusement Parks',
                        value: 'amusement_park',
                        checked: false,
                    },
                ],
            },
            {
                text: 'Local Rental Services',
                all: false,
                types: [
                    {
                        text: 'Local Language Lessons',
                        value: 'school',
                        checked: false,
                    },
                    {
                        text: 'Car Rental',
                        value: 'car_rental',
                        checked: false,
                    },
                    {
                        text: 'Bicycle & Scooter Rental',
                        value: 'bicycle_store',
                        checked: false,
                    },
                    {
                        text: 'Airport Shuttle',
                        value: 'airport',
                        checked: false,
                    },
                    {
                        text: 'Taxi',
                        value: 'taxi_stand',
                        checked: false,
                    },
                    {
                        text: 'Dry cleaner',
                        value: 'laundry',
                        checked: false,
                    },
                ],
            },
            {
                text: 'Health & Personal Care',
                all: false,
                types: [
                    {
                        text: 'Barbershops, Hairdresser / Beauty Salon',
                        value: 'beauty_salon,hair_care',
                        checked: false,
                    },
                    {
                        text: 'Hospital / Emergency',
                        value: 'hospital',
                        checked: false,
                    },
                    {
                        text: 'Local Dentist',
                        value: 'dentist',
                        checked: false,
                    },
                    {
                        text: 'Local Doctor',
                        value: 'doctor',
                        checked: false,
                    },
                    {
                        text: 'Spa, Massage & Sauna',
                        value: 'spa',
                        checked: false,
                    },
                    {
                        text: 'Pharmacies',
                        value: 'drugstore',
                        checked: false,
                    },
                    {
                        text: 'Gym',
                        value: 'gym',
                        checked: false,
                    },
                ],
            },
            {
                text: 'Accommodations',
                all: false,
                types: [
                    {
                        text: 'Hotels',
                        value: 'lodging',
                        checked: false,
                    },
                    {
                        text: 'Campaigns',
                        value: 'rv_park',
                        checked: false,
                    },
                ],
            },
            {
                text: 'Sports & Leisure',
                all: false,
                types: [
                    {
                        text: 'Local Gym',
                        value: 'gym',
                        checked: false,
                    },
                    {
                        text: 'Nature & Adventure',
                        value: 'natural_feature',
                        checked: false,
                    },
                ],
            },
            {
                text: 'Shopping',
                all: false,
                types: [
                    {
                        text: 'Local Art',
                        value: 'art_gallery',
                        checked: false,
                    },
                    {
                        text: 'Souvenirs',
                        value: 'store',
                        checked: false,
                    },
                    {
                        text: 'Wines and Alcohol',
                        value: 'liquor_store',
                        checked: false,
                    },
                    {
                        text: 'Fashion',
                        value: 'jewelry_store,clothing_store,shoe_store',
                        checked: false,
                    },
                    {
                        text: 'Shopping Centres',
                        value: 'shopping_mall',
                        checked: false,
                    },
                ],
            },
        ];
        _this.localStorageCacheName = localStorageKeys.googlePlaceTypeToPull;
        _this.toggleAndDataSourceStore.toggleAndDataSourceCommand
            .takeUntil(_this.isDestroyed)
            .subscribe(function (toggleCommand) {
            var customDefaultPlaceCategory = LocalStorageService.getCustomDefaultPlaceCategoryFromLocalStorage();
            console.log('customDefaultPlaceCategory in pull google type', customDefaultPlaceCategory);
            // if (!customDefaultPlaceCategory || customDefaultPlaceCategory.useDefault) {
            if (toggleCommand && toggleCommand.dataSource) {
                if (toggleCommand.dataSource.businessType === 'area business') {
                    _this.sources = _this.sourceOfAreaBusiness;
                    _this.localStorageCacheName = localStorageKeys.googlePlaceTypeToPullForAreaBusiness;
                }
                if (toggleCommand.dataSource.businessType === 'local secrets') {
                    _this.sources = _this.sourceOfLocalSecrets;
                    _this.localStorageCacheName = localStorageKeys.googlePlaceTypeToPullForLocalSecrets;
                }
            }
            // }
            var lastTimeSelected = localStorage.getItem(_this.localStorageCacheName);
            if (lastTimeSelected) {
                var selected_1 = JSON.parse(lastTimeSelected);
                _this.sources.forEach(function (x) {
                    x.types.filter(function (y) { return selected_1.any(function (z) { return z.value === y.value; }); }).forEach(function (m) { return (m.checked = true); });
                });
            }
        });
        return _this;
    }
    PullGooglePlaceTypeModalComponent.prototype.selectAll = function (mainType) {
        if (mainType) {
            mainType.types.forEach(function (x) { return (x.checked = mainType.all); });
            this.checkIsAll();
        }
    };
    PullGooglePlaceTypeModalComponent.prototype.allIn = function () {
        var _this = this;
        this.sources.forEach(function (x) {
            x.all = _this.isSelectAll;
            x.types.forEach(function (y) { return (y.checked = _this.isSelectAll); });
        });
    };
    PullGooglePlaceTypeModalComponent.prototype.onSelect = function (mainType) {
        if (mainType) {
            if (mainType.types.any(function (x) { return !x.checked; })) {
                mainType.all = false;
            }
            else {
                mainType.all = true;
            }
            this.checkIsAll();
        }
    };
    PullGooglePlaceTypeModalComponent.prototype.confirm = function () {
        var selected = [];
        this.sources.forEach(function (x) {
            selected.push.apply(selected, x.types
                .filter(function (y) { return y.checked; })
                .map(function (z) {
                return { text: z.text, value: z.value };
            }));
        });
        localStorage.setItem(this.localStorageCacheName, JSON.stringify(selected));
        this.actions.confirm(selected);
        this.dialogRef.close();
    };
    PullGooglePlaceTypeModalComponent.prototype.close = function () {
        if (this.actions.cancel) {
            this.actions.cancel();
        }
        this.dialogRef.close();
    };
    PullGooglePlaceTypeModalComponent.prototype.checkIsAll = function () {
        this.isSelectAll = this.sources.every(function (x) { return x.all; });
    };
    return PullGooglePlaceTypeModalComponent;
}(BaseComponent));
export { PullGooglePlaceTypeModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/pull.google.place.type.modal/pull.google.place.type.modal.component.ts.pre-build-optimizer.js